/**
 * Headers auth + cabinet actif (multi-cabinets).
 */
export function getActiveCabinetId() {
  try {
    const raw = sessionStorage.getItem('activeCabinet');
    if (!raw) return null;
    const cab = JSON.parse(raw);
    const id = parseInt(cab?.id, 10);
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch (_) {
    return null;
  }
}

export function authJsonHeaders(extra = {}) {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const cabinetId = getActiveCabinetId();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(cabinetId ? { 'X-Cabinet-Id': String(cabinetId) } : {}),
    ...extra,
  };
}
